/** @jsxImportSource @emotion/react */
import { Box, Tab, Tabs } from '@mui/material'
import { useMemo } from 'react'
import { Link as RouterLink, useLocation, useResolvedPath } from 'react-router-dom'

type Props = {
  layerType?: string
}

const DataLayerDetailTabs = ({ layerType = '' }: Props) => {
  const location = useLocation()
  const basePath = useResolvedPath('.').pathname

  const normalizePath = (p: string) => (p.length > 1 ? p.replace(/\/+$/, '') : p)

  const base = normalizePath(basePath)
  const current = normalizePath(location.pathname)

  const tabLink = useMemo(
    () => ({
      overview: `${base}/overview`,
      scenarios: `${base}/scenarios`,
      suitability: `${base}/suitability`,
      attributes: `${base}/attributes`,
    }),
    [base],
  )

  const activeTab = useMemo(() => {
    const match = Object.values(tabLink)
      .filter((path) => current === path || current.startsWith(`${path}/`))
      .sort((a, b) => b.length - a.length)[0]

    return match ?? false
  }, [current, tabLink])

  return (
    <Box>
      <Tabs value={activeTab}>
        <Tab
          label="Overview"
          value={tabLink.overview}
          component={RouterLink}
          to="overview"
          replace
        />
        {['Hazard'].includes(layerType) && (
          <Tab
            label="Scenarios"
            value={tabLink.scenarios}
            component={RouterLink}
            to="scenarios"
            replace
          />
        )}
        {['Hazard'].includes(layerType) && (
          <Tab
            label="Suitability"
            value={tabLink.suitability}
            component={RouterLink}
            to="suitability"
            replace
          />
        )}
        {['Element', 'Contextual'].includes(layerType) && (
          <Tab
            label="Attributes"
            value={tabLink.attributes}
            component={RouterLink}
            to="attributes"
            replace
          />
        )}
      </Tabs>
    </Box>
  )
}

export default DataLayerDetailTabs
